import { useNavigate } from 'react-router-dom';
import { Icon } from './Icon';

export interface Crumb { label: string; to?: string; }

/**
 * Breadcrumb di pagina (pattern reference): back circolare + trail cliccabile.
 * Sostituisce i "← Torna a X" sparsi nelle pagine dettaglio.
 */
export function Breadcrumb({ items }: { items: Crumb[] }) {
  const navigate = useNavigate();
  const backTo = [...items].reverse().find((c) => c.to)?.to;
  return (
    <nav className="breadcrumb" aria-label="Percorso">
      {backTo && (
        <button type="button" className="bc-back" aria-label="Torna indietro" onClick={() => navigate(backTo)}>
          <Icon name="arrowLeft" size={14} />
        </button>
      )}
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="bc-item">
            {c.to && !last
              ? <span role="link" tabIndex={0} className="bc-link" onClick={() => navigate(c.to!)} onKeyDown={(e) => e.key === 'Enter' && navigate(c.to!)}>{c.label}</span>
              : <span className="bc-current" aria-current={last ? 'page' : undefined}>{c.label}</span>}
            {!last && <Icon name="chevronR" size={12} className="bc-sep" />}
          </span>
        );
      })}
    </nav>
  );
}
